import classnames from 'classnames';
import { ReactComponent as UserCenterIcon } from 'img/mobileFooterMenu/user-center.svg';
import { ReactComponent as HelpIcon } from 'img/mobileFooterMenu/help.svg';
import { ReactComponent as HomeIcon } from 'img/mobileFooterMenu/home.svg';
import { ReactComponent as ChatIcon } from 'img/mobileFooterMenu/chat.svg';
import { ReactComponent as LineIcon } from 'img/mobileFooterMenu/line.svg';

import './index.css';
import { useTranslation } from 'react-i18next';

const activeKey = 'home';

const IconButton = ({ icon, text, active, onClick }) => {
  const classNames = classnames('iconButtonContainer', {
    active: active,
  });

  const handleClick = () => {
    onClick?.();
  };

  return (
    <div className={classNames} onClick={handleClick}>
      {icon}
      <span className="iconButtonText">{text}</span>
    </div>
  );
};

const MobileFooterMenu = () => {
  const { t } = useTranslation();

  const buttons = [
    {
      key: 'userCenter',
      icon: <UserCenterIcon />,
      text: t('MobileFooterMenu.button_userCenter'),
      onClick: () => {
        console.log('footer_user-center');
      },
    },
    {
      key: 'help',
      icon: <HelpIcon />,
      text: t('MobileFooterMenu.button_help'),
      onClick: () => {
        console.log('footer_help');
      },
    },
    {
      key: 'home',
      icon: <HomeIcon />,
      text: t('MobileFooterMenu.button_home'),
      onClick: () => {
        console.log('footer_home');
      },
    },
    {
      key: 'chat',
      icon: <ChatIcon />,
      text: t('MobileFooterMenu.button_chat'),
      onClick: () => {
        console.log('footer_chat');
      },
    },
    {
      key: 'line',
      icon: <LineIcon />,
      text: t('MobileFooterMenu.button_line'),
      onClick: () => {
        console.log('footer_line');
      },
    },
  ];

  return (
    <div className="mobileFooterMenuWrapper">
      <div className="mobileFooterMenuContainer">
        {buttons.map(({ key, icon, text, onClick }) => (
          <IconButton key={key} icon={icon} text={text} active={key === activeKey} onClick={onClick} />
        ))}
      </div>
    </div>
  );
};

export default MobileFooterMenu;
